import { ToastrService } from 'ngx-toastr';
import {
  StudentCourseModel, StudentClassMappingModel, GroupedStudent,
} from '../../../Elearning-Models';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { IServiceFactory } from '../../../Services/service-factory';
import { CurriculumService } from 'src/app/Services/curriculum.service';
import { UserIconColors, ColorCodes } from 'src/app/ColorCodes';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-student-course',
  templateUrl: './student-course.component.html',
  styleUrls: ['./student-course.component.scss'],
})
export class StudentCourseComponent implements OnInit {
  public dataService: CurriculumService;
  public studentCourseData: StudentCourseModel;
  public groupedStudents: GroupedStudent[];
  public colors = UserIconColors;
  public colorsLength: number = Object.keys(UserIconColors).length / 2;
  imagePath = environment.imagePath + 'assets/images/curriculumImages/';


  public curriculumDataReceived = false;

  constructor(
    public dialog: MatDialog,
    private serviceFactory: IServiceFactory,
    private router: Router,
  ) {
    this.dataService = serviceFactory.getCurriculumService();
  }

  ngOnInit(): void {
    this.GetStudentCourseList();
  }

  /**
   * This method is used to get selected Curriculum Data.
   */ 
   GetStudentCourseList = (): void => {
    this.curriculumDataReceived = false;
    this.dataService.GetStudentCourseList().subscribe(response => {
      this.studentCourseData = response;
      this.groupStudents(this.studentCourseData?.StudentCurriculums);
      this.curriculumDataReceived = true; 
    });
  };;

  /**
   * This method is used to redirect to curriculum view page.
   */
   studentClassAction = (data: StudentClassMappingModel): void => {
    if (data.HasPaid || !data.HasCompletedDemo){
      this.router.navigate([environment.rootPath + 'CurriculumView/', data.ClassID])
    } else if (data.HasCompletedDemo){
      this.router.navigate([environment.rootPath + 'CurriculumDiagnosticFeatures/' + 
        data.StudentID + '/' + data.ClassID],
      );
    } 
  }

  groupBy(array, key): any[][]
  {
    return array.reduce((result, currentValue) => {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(
        currentValue
      );
      return result;
    }, []);
  };

  groupStudents(students: StudentClassMappingModel[]){
    this.groupedStudents = [];
    students.forEach(s => {
      var alreadyGroupedStudent = this.groupedStudents?.find(gs => gs.StudentID == s.StudentID);
      if(alreadyGroupedStudent){
        alreadyGroupedStudent.Classes.push(s);
      }
      else{
        var newGroupedStudent = new GroupedStudent();
        newGroupedStudent.StudentID = s.StudentID;
        newGroupedStudent.Classes = [];
        newGroupedStudent.Classes.push(s);
        this.groupedStudents.push(newGroupedStudent);
      }
    });

    this.groupedStudents.sort((a, b) => this.sortFunction(a.Classes[0].StudentFirstName, b.Classes[0].StudentFirstName) );
  }

  sortFunction(a: String, b: String){
   
    if(a < b)
    {
      return -1;
    }
    else if(a > b)
    {
      return 1;
    }
    else
    {
      return 0;
    }
  }

}
